<template>
  <v-container>
    <v-row justify="space-between" dense>
      <v-row align="start" justify="center">
        <v-col cols="12">
          <v-card class="elevation-2">
            <title-bar></title-bar>
            <v-card-title class="primary--text text-h6 pl-4 font-weight-bold"
              >WORK EXPERIENCE</v-card-title
            >
            <v-card-text>
              (please provide details of the last three positions you've held)
              <v-checkbox
                label="Check here if this would be your first work experience"
                @change="handleFirstJobCheck"
              />
            </v-card-text>
            <v-card-text v-if="!firstJob">
              <v-form ref="form" v-model="valid" lazy-validation>
                <span v-for="index in 3" :key="index">
                  <v-card
                    class="mb-3"
                    v-if="index == 1 || work[index - 1].company"
                  >
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="work[index].company"
                            prepend-inner-icon="mdi-briefcase-outline"
                            :label="
                              index == '1' ? 'Company Name *' : 'Company Name'
                            "
                            :rules="
                              index == '1' && !firstJob ? requiredRules : ''
                            "
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="work[index].position"
                            :label="
                              index == '1'
                                ? 'Position/Duties *'
                                : 'Position/Duties'
                            "
                            :rules="
                              index == '1' && !firstJob ? requiredRules : ''
                            "
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="work[index].supervisor"
                            :label="
                              index == '1' ? 'Supervisor *' : 'Supervisor'
                            "
                            :rules="
                              index == '1' && !firstJob ? requiredRules : ''
                            "
                            placeholder="Name/Phone Number"
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="work[index].dates"
                            :label="
                              index == '1'
                                ? 'Dates Employeed *'
                                : 'Dates Employeed'
                            "
                            :rules="
                              index == '1' && !firstJob ? requiredRules : ''
                            "
                            placeholder="MM/YY - MM/YY"
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="work[index].reason"
                            :label="
                              index == '1'
                                ? 'Reason for Leaving *'
                                : 'Reason for Leaving'
                            "
                            :rules="
                              index == '1' && !firstJob ? requiredRules : ''
                            "
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" md="6">
                          <v-checkbox
                            v-model="work[index].reference"
                            label="Yes, we may contact for reference?"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </span>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="secondary" @click="previous">Previous</v-btn>
              <v-btn class="mr-5" color="primary" @click="formSubmit"
                >Next</v-btn
              >
            </v-card-actions>
            <footer-bar></footer-bar>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import TitleBar from "../components/TitleBar";
import FooterBar from "../components/Footer";

export default {
  components: { TitleBar, FooterBar },

  computed: {
    work: {
      get() {
        return this.$store.state.work;
      },
      set(value) {
        this.$store.commit("setWork", { work: value });
      },
    },
    app_state: {
      get() {
        return this.$store.state;
      },
    },
  },

  data: () => ({
    valid: false,
    loading: true,
    firstJob: false,
    requiredRules: [(v) => !!v || "This field is required"],
  }),
  props: {
    source: String,
  },

  methods: {
    formSubmit(e) {
      e.preventDefault();
      if (this.firstJob) {
        this.$router.push({ name: "P5" });
      } else if (this.$refs.form.validate()) {
        this.$router.push({ name: "P5" });
      }
    },
    previous(e) {
      e.preventDefault();
      this.$router.push({ name: "P3" });
    },
    handleFirstJobCheck(e) {
      this.firstJob = e ? true : false;
    },
  },

  /* beforeRouteLeave (to, from , next) {
    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  }*/
};
</script>
